module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/passion_2x.2ac4c3a.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/passion_2x.png
// module id = nTnu
// module chunks = 41